export const printStatus = (issuer = null) => {
  if (!issuer) {
    return 'Väntar på godk.'
  }

  return issuer
}

export const capitalizeName = (name) => {
  const trimmedName = name.trim()

  return trimmedName.charAt(0).toUpperCase() + trimmedName.substring(1).toLowerCase()
}